import React from "react";
import LogisticsPlan from "./LogisticsPlan";

function Logistics({ shippingTerms, shippingZone }) {
  return (
    <LogisticsPlan shippingTerms={shippingTerms} shippingZone={shippingZone} />
  );
}

export default Logistics;
